export const calculateDuration = (startTime: string, endTime: string) => {
  const start = new Date(startTime);
  const end = new Date(endTime);

  let normalizedEndTime = new Date(
    Date.UTC(
      start.getUTCFullYear(),
      start.getUTCMonth(),
      start.getUTCDate(),
      end.getUTCHours(),
      end.getUTCMinutes(),
      end.getUTCSeconds(),
      end.getUTCMilliseconds(),
    ),
  );

  // If normalized end is before start, session crossed midnight - add 1 day
  if (normalizedEndTime.getTime() < start.getTime()) {
    normalizedEndTime = new Date(
      normalizedEndTime.getTime() + 24 * 60 * 60 * 1000,
    );
  }

  const durationInMins = Math.floor(
    (normalizedEndTime.getTime() - start.getTime()) / (1000 * 60),
  );
  return durationInMins;
};
